import React, { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { api } from '../api/client'
import AuthCard, { authCardStyles as s } from './AuthCard'
import { ROUTES } from '../routes'
import { EMAIL_VERIFIED, translateAuthError } from '../authMessages'

// Страница по ссылке из письма подтверждения. Публичная: пользователь может
// открыть ссылку в браузере, где он не авторизован.
export default function VerifyEmailPage () {
  const [params] = useSearchParams()
  const token = params.get('token')
  const [status, setStatus] = useState('checking') // checking | ok | error
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!token) {
      setError(translateAuthError({ code: 'EMAIL_VERIFY_TOKEN_INVALID' }))
      setStatus('error')
      return
    }
    let cancelled = false
    api.verifyEmail(token)
      .then(() => { if (!cancelled) setStatus('ok') })
      .catch(err => {
        if (cancelled) return
        setError(translateAuthError(err))
        setStatus('error')
      })
    return () => { cancelled = true }
  }, [token])

  return (
    <AuthCard>
      {status === 'checking' && <div style={s.hint}>Проверяем ссылку…</div>}

      {status === 'ok' && (
        <div style={s.form}>
          <div style={s.notice} role='status'>{EMAIL_VERIFIED}</div>
          <Link style={s.link} to={ROUTES.INTEGRATIONS}>Перейти в платформу</Link>
        </div>
      )}

      {status === 'error' && (
        <div style={s.form}>
          <div style={s.error} role='alert'>{error}</div>
          <Link style={s.link} to={ROUTES.LOGIN}>Вернуться к входу</Link>
        </div>
      )}
    </AuthCard>
  )
}
